export default {
  "content": "<g clip-path=\"url(#clip0_316_15610)\"><path d=\"M11.83 3.12l-2.075-.786a.315.315 0 00-.233.006L4.544 4.452V6.83l-1.202-.466.005-2.372L8.45 1.825l-1.94-.742H6.49l-5.32 2.004a.136.136 0 00-.086.125v6.289c0 .06.033.108.087.13l5.156 2.204c.13.054.271.06.407.006 1.007-.396 5.183-2.248 5.183-2.248V3.25a.136.136 0 00-.086-.13z\" fill=\"#717684\"/></g><defs><clipPath id=\"clip0_316_15610\"><path fill=\"#fff\" d=\"M0 0h13v13H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "13",
    "height": "13",
    "viewBox": "0 0 13 13",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};